/*
* 新增广告活动-广告格式
*/
<template>
  <div>
    <el-form ref="advertising-format" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item prop="adFormat" label="广告格式">
            <template #label>
              广告格式
              <gj-help style="padding-left: 3px">广告格式是可以帮助您根据要推广的内容创建广告的模板。</gj-help>
            </template>
            <div class="advertising-format-content">
              <!-- 商品集 -->
              <div class="advertising-format-cell collection" :class="{active: form.adFormat == 0}" @click="change(0)">
                <div class="title">商品集</div>
                <div class="main">
                  <div class="block">
                    <div class="block-1">
                      <div class="block-cell" :class="`block-1-${item}`" v-for="item in 4" :key="item"></div>
                    </div>
                    <div class="block-2">
                      <div class="block-cell" v-for="item in 3" :key="item"></div>
                    </div>
                  </div>
                  <div class="msg">图文形式，可引流至商品详情页，推广多件商品</div>
                </div>
              </div>
              <!-- 视频 -->
              <div class="advertising-format-cell video" :class="{active: form.adFormat == 1, 'no-click': !isJurisdiction}" @click="change(1)">
                <div class="title">视频 <span class="tag" v-if="!isJurisdiction">亚马逊当前站点不支持视频！</span></div>
                <div class="main">
                  <div class="block">
                    <div class="block-0 block-cell">
                      <div class="arrow"></div>
                    </div>
                    <div class="block-1">
                      <div class="block-cell" :class="`block-1-${item}`" v-for="item in 4" :key="item"></div>
                    </div>
                  </div>
                  <div class="msg">自动播放视频展示单件商品</div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <LandingPageCollection v-if="form.adFormat == 0" :noBrand="noBrand"/> <!-- 商品集 -->
          <LandingPageVideo  v-else-if="form.adFormat == 1"/> <!-- 视频 -->
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import LandingPageCollection from './landing-page-collection'
import LandingPageVideo from './landing-page-video'
import { AdCampaignEnum } from "modules/ad/common/enum.js"
export default {
    name: "add-advertising-format",
    inject: ['getForms', 'getPublicObj'],
    components: {LandingPageCollection, LandingPageVideo},
    props: {
      noBrand: {
        default: true
      }
    },
    data() {
      return {
        form: {},
        creative: {},
        temporaryStorage: { // 临时储存
          asinsV: [],
          asinsF: [],
          asinsItemV: [],
          asinsItemF: [],
          adFormatUrl: null,
          landingPage: {
            asins: [],
            url: []
          },
        },
        rules: {
          adFormat: [
            { required: true, message: '请选择广告格式', trigger: 'change' }
          ],
        }
      }
    },
    computed: {
      publicObj() {
        return this.getPublicObj()
      },
      // 仅支持美国、德国、英国站点，根据站点判断是否可选
      isJurisdiction() {
        return AdCampaignEnum.SB.marketVideo.includes(this.publicObj.SB.market.countryCode)
      }
    },
    methods: {
      change(val) {
        this.form.adFormat = val
        if (val === 0) {// 商品集
          // 储存
          this.temporaryStorage.asinsV = this.creative.asins
          this.temporaryStorage.asinsItemV = this.creative.asinsItem
          // 清空
          this.creative.asins = this.temporaryStorage.asinsF
          this.creative.asinsItem = this.temporaryStorage.asinsItemF
          // 设置
          this.form.adFormatUrl = this.temporaryStorage.adFormatUrl
          this.form.landingPage.asins = this.temporaryStorage.landingPage.asins
          this.form.landingPage.url = this.temporaryStorage.landingPage.url
        }else if (val === 1) {// 视频
          // 储存
          this.temporaryStorage.adFormatUrl = this.form.adFormatUrl
          this.temporaryStorage.landingPage.asins = this.form.landingPage.asins
          this.temporaryStorage.landingPage.url = this.form.landingPage.url
          this.temporaryStorage.asinsF = this.creative.asins
          this.temporaryStorage.asinsItemF = this.creative.asinsItem
          // 清空
          this.form.adFormatUrl = null
          this.form.landingPage.asins = []
          this.form.landingPage.url = null
          // 设置
          this.creative.asins = this.temporaryStorage.asinsV
          this.creative.asinsItem = this.temporaryStorage.asinsItemV
        }
      }
    },
    created() {
      let { addAdvertisingFormat, creative } = this.getForms()
      this.form = addAdvertisingFormat
      this.creative = creative
    }
}
</script>

<style scoped lang="scss">
@mixin block-style($width, $height, $top, $left) {
  width: $width;
  height: $height;
  top: $top;
  left: $left;
}
.advertising-format-content {
  display: flex;
  .advertising-format-cell {
    width: 427px;
    height: 130px;
    padding: 12px 18px;
    line-height: 1;
    font-size: 12px;
    margin-right: 20px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #E4E5E6;
    border-radius: 4px;
    .title {
      padding-bottom: 12px;
      .tag {
        display: inline-block;
        color: #f00;
        transform: scale(.8) translateX(-18px);
      }
    }
    .main {
      display: flex;
      .block {
        flex: 1;
        .block-cell {
          background: #E4E5E6;
        }
        .block-0 {
          width: 244px;
          height: 65px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          .arrow {
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-left: 24px solid #CDCDCD;
            border-bottom: 12px solid transparent;
          }
        }
        .block-1 {
          height: 40px;
          position: relative;
          .block-cell {
            position: absolute;
          }
          .block-1-1 {
            @include block-style(49px, 23px, 0, 0)
          }
          .block-1-2 {
            @include block-style(186px, 8px, 0, 59px)
          }
          .block-1-3 {
            @include block-style(33px, 8px, 15px, 59px)
          }
          .block-1-4 {
            @include block-style(33px, 8px, 15px, 110px)
          }
        }
        .block-2 {
          display: flex;
          .block-cell {
            width: 75px;
            height: 56px;
            margin-right: 10px;
          }
        }
      }
      .msg {
        width: 145px;
        line-height: 18px;
        color: #969696;
      }
    }
    &.active {
      border: 1px solid #1F6EEF;
      background: rgba(31,110,239,0.04);
      .arrow {
        border-left: 24px solid rgba(31, 111, 239, 0.2) !important;
      }
      .block-cell {
        background: rgba(31,110,239,0.20) !important;
      }
      .title {
        color: #1F6EEF;
        font-weight: 500;
      }
      .msg {
        color: rgba(31, 110, 239, .7);
      }
    }
    &.collection {}
    &.video {}
    &.no-click {
      pointer-events: none;
      background: #F6F6F8;
    }
  }
}
</style>